<template>
  <v-dialog
    overlay-color="blue-grey darken-3"
    width="450"
    :value="visible"
    @input="handleInput"
  >
    <v-card class="ma-0 pa-0">
      <v-card-title class="py-4 px-6">
        <p class="blue-grey--text text--darken-3 h6 ma-0 pa-0">
          {{ title }}
        </p>
      </v-card-title>

      <v-card-text class="ma-0 py-0 px-6 pt-3">
        <slot name="content" />
      </v-card-text>
      <v-divider class="mt-6 mb-4" />
      <v-card-actions class="ma-0 pa-0 d-flex justify-end pb-4 px-6">
        <slot name="footer" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EditDialog',

  props: {
    visible: Boolean,
    title: String,
  },

  methods: {
    handleInput(event) {
      const close = !event
      if (close) this.$emit('close')
    },
  },
}
</script>
